(() => {
  if (window.bjAppstleSubscriptionReady) return;
  window.bjAppstleSubscriptionReady = true;

  const INFO_PAGE = '/pages/subscribe-save';
  const SUBSCRIPTION_COPY =
    'Save 15% on your first order, then save 10% on all future subscription orders.';

  const simplifyPlanName = (name) =>
    String(name || '')
      .replace(/^Subscribe\s*&\s*Save\s*[^A-Za-z0-9]*\s*/i, '')
      .trim();

  const syncWidgetState = (widget) => {
    widget
      .querySelectorAll('.appstle_subscription_wrapper > .appstle_subscription_wrapper_option')
      .forEach((option) => {
        const radio = option.querySelector('input[type="radio"][name="selling_plan"]');
        const isSelected = Boolean(radio?.checked);
        option.classList.toggle('appstle-active-option', isSelected);
        option.classList.toggle('appstle_selected_background', isSelected);
      });
  };

  const enhanceFrequency = (widget, subscriptionOption) => {
    const nativeWrapper = subscriptionOption.querySelector('.appstleRadioSellingPlanWrapper');
    if (!nativeWrapper || nativeWrapper.dataset.bjEnhanced === 'true') return;

    const planRadios = Array.from(nativeWrapper.querySelectorAll('input[type="radio"]'));
    if (!planRadios.length) return;

    nativeWrapper.dataset.bjEnhanced = 'true';
    const row = document.createElement('div');
    row.className = 'bj-appstle-frequency';
    row.innerHTML = `
      <label class="bj-appstle-frequency__label">Deliver Every</label>
      <select class="bj-appstle-frequency__select" aria-label="Delivery frequency"></select>
    `;

    const select = row.querySelector('select');
    planRadios.forEach((radio) => {
      const option = document.createElement('option');
      option.value = radio.value;
      option.textContent = simplifyPlanName(
        Array.from(nativeWrapper.querySelectorAll('label')).find(
          (label) => label.htmlFor === radio.id
        )?.textContent
      );
      option.selected = radio.checked;
      select.append(option);
    });

    select.addEventListener('change', () => {
      const subscriptionRadio = subscriptionOption.querySelector(
        'input[type="radio"][name="selling_plan"]'
      );
      const selectedPlan = planRadios.find((radio) => radio.value === select.value);

      if (subscriptionRadio && !subscriptionRadio.checked) {
        subscriptionRadio.click();
      }
      if (selectedPlan) {
        selectedPlan.click();
      }
      window.setTimeout(() => syncWidgetState(widget), 0);
    });

    planRadios.forEach((radio) => {
      radio.addEventListener('change', () => {
        if (radio.checked) select.value = radio.value;
      });
    });

    nativeWrapper.insertAdjacentElement('afterend', row);
    widget.classList.add('bj-appstle-enhanced');
  };

  const enhanceWidget = (widget) => {
    if (!widget) return;
    const subscriptionOption = widget.querySelector('.appstle_include_dropdown');
    if (!subscriptionOption) return;
    widget.dataset.bjEnhanced = 'true';

    if (!subscriptionOption.querySelector('.bj-appstle-subtext')) {
      const copy = document.createElement('p');
      copy.className = 'bj-appstle-subtext';
      copy.textContent = SUBSCRIPTION_COPY;
      subscriptionOption
        .querySelector('.appstle_subscription_radio_wrapper')
        ?.insertAdjacentElement('afterend', copy);
    }

    if (!widget.querySelector('.bj-appstle-info-link')) {
      const infoLink = document.createElement('a');
      infoLink.className = 'bj-appstle-info-link';
      infoLink.href = INFO_PAGE;
      infoLink.textContent = 'How Subscribe & Save works';
      widget.insertAdjacentElement('beforeend', infoLink);
    }

    enhanceFrequency(widget, subscriptionOption);
    syncWidgetState(widget);

    if (widget.dataset.bjListeners !== 'true') {
      widget.dataset.bjListeners = 'true';
      widget.addEventListener('change', () => {
        window.setTimeout(() => syncWidgetState(widget), 0);
      });
      widget.addEventListener('click', () => {
        window.setTimeout(() => syncWidgetState(widget), 0);
      });
    }
  };

  const enhanceWidgets = () => {
    document.querySelectorAll('.appstle_sub_widget').forEach(enhanceWidget);
    document.querySelectorAll('.appstle_tooltip_appstle').forEach((footer) => footer.remove());
  };

  const getCartSections = () =>
    Array.from(
      new Set(
        Array.from(document.querySelectorAll('.shopify-section[id]'))
          .map((section) => section.id.replace(/^shopify-section-/, ''))
          .filter((id) => id === 'cart-drawer' || id.includes('main-cart'))
      )
    );

  const updateCartLine = async (control, sellingPlan) => {
    const select = control.querySelector('[data-bj-cart-subscription-select]');
    const button = control.querySelector('[data-bj-cart-subscription-upgrade]');
    const selector = control.querySelector('[data-bj-cart-subscription-selector]');
    const valueLabel = control.querySelector('[data-bj-cart-subscription-select-value]');
    const currentSellingPlan = control.dataset.currentSellingPlan || '';
    const nextSellingPlan = sellingPlan || '';
    const selectedOption = select?.selectedOptions?.[0];
    const selectedText = selectedOption?.textContent?.trim();
    const previousText = valueLabel?.textContent?.trim();

    if (control.classList.contains('is-updating')) return;
    if (currentSellingPlan === nextSellingPlan) return;

    control.classList.add('is-updating');
    if (select) {
      select.value = nextSellingPlan;
      select.disabled = !nextSellingPlan;
      select.dataset.pendingValue = nextSellingPlan;
      if (selectedText) select.dataset.pendingText = selectedText;
    }
    if (valueLabel) valueLabel.textContent = selectedText || previousText || '';
    if (button) {
      button.disabled = true;
      button.hidden = Boolean(nextSellingPlan);
      button.textContent = nextSellingPlan
        ? 'Updating subscription...'
        : 'Downgrading to one-time...';
    }
    if (selector) {
      selector.hidden = !nextSellingPlan;
    }

    try {
      const sections = getCartSections();
      const response = await fetch(window.theme?.routes?.cart_change_url || '/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: control.dataset.lineKey,
          selling_plan: sellingPlan || null,
          sections,
          sections_url: window.location.pathname
        })
      });
      if (!response.ok) throw new Error('Unable to update subscription');

      const cart = await response.json();
      document.dispatchEvent(
        new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: { cart, open: true }
        })
      );

      if (window.location.pathname === '/cart') window.location.reload();
    } catch (error) {
      console.warn('[Blinkjoy] Subscription cart update failed.', error);
      window.alert('We could not update the subscription option. Please try again.');
      control.classList.remove('is-updating');
      if (select) {
        select.disabled = false;
        select.value = currentSellingPlan;
        delete select.dataset.pendingValue;
        delete select.dataset.pendingText;
      }
      if (valueLabel) valueLabel.textContent = previousText || '';
      if (selector) selector.hidden = !currentSellingPlan;
      if (button) {
        button.disabled = false;
        button.hidden = Boolean(currentSellingPlan);
        button.textContent = 'Upgrade to Subscription & Save 15%';
      }
    }
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-bj-cart-subscription-upgrade]');
    if (!button) return;
    event.preventDefault();

    const control = button.closest('[data-bj-cart-subscription]');
    const firstSubscriptionPlan = control?.querySelector(
      '[data-bj-cart-subscription-select] option[value]:not([value=""])'
    );
    if (control && firstSubscriptionPlan) {
      updateCartLine(control, firstSubscriptionPlan.value);
    }
  });

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-bj-cart-subscription-select]');
    if (!select) return;
    event.preventDefault();
    event.stopPropagation();

    const control = select.closest('[data-bj-cart-subscription]');
    if (control) updateCartLine(control, select.value);
  }, true);

  enhanceWidgets();
  new MutationObserver(enhanceWidgets).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
